<template>
  <div>
    <el-card>
      <div class="top">
        <div class="left">
          <span class="order-detail">美团订单详情</span>
        </div>
        <div class="right">
          <!-- <el-button><i class="el-icon-download"></i> 导出</el-button>
          <el-button> <i class="el-icon-printer"></i>打印</el-button> -->
          <el-button @click="back">
            <i
              class="el-icon-arrow-left
"
            ></i
            >返回</el-button
          >
        </div>
      </div>
      <div
        class="line"
        style="height: 1px;background-color: #e8e8e8;margin-top: 16px;"
      ></div>
      <div style="display: flex;align-items: center;margin-top: 20px;">
        <span
          style="margin-right: 6px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"
        ></span>
        <span style="font-weight: 700;">订单号 {{ data.orderId }}</span>
        <span class="yjz" v-if="data.status=='1' ||data.status=='2' " >待接单</span>
        <span class="yjz" v-if="data.status=='4' " >已接单</span>
        <span class="yjz" v-if="data.status=='6' " >已配送</span>
        <span class="yjz" v-if="data.status=='8' " >已完成</span>
        <span class="yjz" v-if="data.status=='9' " >已取消</span>
        <!-- <span style="font-size: 12px;color: #FD8D02;margin-left: 10px;"
          >查看联台订单号明细</span
        > -->
      </div>
      <div class="three-card">
        <div class="item">
          <div class="top">
            <span>订单金额(元)</span>
            <span style="margin-left: 8px;">{{ data.originalPrice }}</span>
          </div>
        </div>
        <div class="item">
          <div class="top">
            <span>订单优惠(元)</span>
            <span style="margin-left: 8px;">{{
              data.originalPrice== null || data.total==null
                ? ""
                : data.originalPrice - data.total
            }}</span>
          </div>
          <div class="bottom">
            <!-- <span>折扣优惠-0.00 + 支付优惠-0.00</span> -->
          </div>
        </div>
        <div class="item">
          <div class="top">
            <span>订单收入(元)</span>
            <span style="margin-left: 8px;">{{ data.total }}</span>
          </div>
        </div>
      </div>
      <div class="three-detail">
        <div class="item">
          <span
            >门店：<span v-if="data.poiName != '' && data.poiName!=null">{{
              data.poiName
            }}</span>
            <span v-else>--</span>
          </span>
          <!-- <span>用餐方式：<span v-if="data.deliveryType!=''">{{ data.deliveryType==0?'堂食':'配送' }}</span>
            <span v-else>--</span>
            </span>
            <span>平台服务费：<span>--</span></span> -->
          <span
            >会员姓名：<span v-if="data.memberName != ''&& data.memberName!=null">{{
              data.memberName
            }}</span>
            <span v-else>--</span>
          </span>
          <span
            >下单时间：<span v-if="data.orderSendTime">{{
              data.orderSendTime | dataFormat
            }}</span>
            <span v-else>--</span>
          </span>
          <span
            >配送时间：
            <span v-if="data.logisticsConfirmTime !=null">{{data.logisticsConfirmTime | dataFormat}}</span>
            <span v-else>--</span>
          </span>
          <span
            >商家确认时间：<span v-if="data.orderConfirmTime!=null">{{
              data.orderConfirmTime| dataFormat
            }}</span>
            <span v-else>--</span>
          </span>
        </div>
        <div class="item">
          <span
            >订单完成时间：
            <span v-if="data.orderCompletedTime != null">{{data.orderCompletedTime | dataFormat}}</span>
            <span v-else>--</span>
          </span>
          <span
            >流水号：<span v-if="data.daySeq != '' && data.daySeq!=null">{{ data.daySeq }}</span>
            <span v-else>--</span></span
          >
          <span
            >用餐人数：<span v-if="data.dinnersNumber">{{
              data.dinnersNumber
            }}</span>
            <span v-else>--</span>
          </span>
          <span
            >订单取消时间：<span v-if="data.orderCancelTime">{{
              data.orderCancelTime | dataFormat
            }}</span>
            <span v-else>--</span>
          </span>

          <span
            >配送费￥：<span v-if="data.shippingFee != '' && data.shippingFee!=null">{{
              data.shippingFee
            }}</span>
            <span v-else>--</span>
          </span>
        </div>
        <div class="item">
          <!-- <span>业务类型：<span>--</span></span> -->
          <span
            >桌台类型：<span v-if="data.tableTypeName != '' && data.tableTypeName!=null">{{
              data.tableTypeName
            }}</span>
            <span v-else>--</span>
          </span>
          <span
            >会员手机号：
            <span v-if="data.memberCardID">{{ data.memberCardID }}</span>
            <span v-else>--</span></span
          >
          <span
            >收货人手机号：
            <span v-if="data.recipientPhone">{{ data.recipientPhone }}</span>
            <span v-else>--</span>
          </span>
          <span
            >收货人姓名：<span
              v-if="data.recipientName != '' && data.recipientName != null"
              >{{ data.recipientName }}</span
            >
            <span v-else>--</span>
          </span>
          <span
            >整单备注：<span v-if="data.caution != '' && data.caution!=null">{{
              data.caution
            }}</span>
            <span v-else>--</span>
          </span>
        </div>
      </div>
      <div style="display: flex;align-items: center;margin-top: 20px;">
        <span
          style="margin-right: 6px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"
        ></span>
        <span style="font-weight: 700;">菜品信息</span>
        <span style="margin-left: 6px;font-size: 14px;" v-if="data.tableName"
          >({{ data.tableName }})</span
        >
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="food_name" label="菜品名称" ></el-table-column>
        <el-table-column prop="price" label="单价(元)"></el-table-column>
        <el-table-column prop="quantity" label="菜品份数"></el-table-column>
        <el-table-column label="做法" prop="food_property"></el-table-column>
       <el-table-column label="规格" prop="spec"></el-table-column>
        <el-table-column label="餐盒数量" prop="box_num"></el-table-column>
        <el-table-column label="餐盒费" prop="box_price"></el-table-column>
        <el-table-column label="单位" prop="unit"></el-table-column>
              <el-table-column label="小计(元)" >
          <template slot-scope="scope">
            {{ scope.row.price * scope.row.quantity + scope.row.box_price*scope.row.box_num }}
          </template>
        </el-table-column>
      </el-table>
                  <div style="display: flex;align-items: center;margin-top: 20px;">
        <span
          style="margin-right: 6px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"
        ></span>
        <span style="font-weight: 700;">配送信息</span>
      </div>
      <el-table :data="couponList">
        <el-table-column
          align="center"
          width="190"
          label="名称"
          prop="dealTitle"
        ></el-table-column>
        <el-table-column
          align="center"
          label="价格(元)"
          prop="couponBuyPrice"
        ></el-table-column>
        <el-table-column
          align="center"
          label="商品"
          prop="content"
        ></el-table-column>
        <el-table-column align="center" label="核销时间">
          <template slot-scope="scope">
            <span>{{ scope.row.updateDt | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">未核销</span>
            <span v-if="scope.row.status == 1">已核销</span>
            <span v-if="scope.row.status == 2">已撤销</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="券类型" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.voucher == true">代金券</span>
            <span v-if="scope.row.voucher == false">套餐券</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;align-items: center;margin-top: 30px;">
        <span
          style="margin-right: 6px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"
        ></span>
        <span style="font-weight: 700;">订单取消信息</span>
      </div>
      <el-table :data="cancelPayData" style="width: 100%">
        <el-table-column label="订单号" prop="orderId"></el-table-column>
        <el-table-column label="商家名称" prop="merchantName"></el-table-column>
        <el-table-column label="取消原因" prop="reason"></el-table-column>
      </el-table>
      <!--  -->

      <!--  -->

      <!-- <div style="display: flex;align-items: center;margin-top: 20px;" v-if="showLastTable"> -->
      <div style="display: flex;align-items: center;margin-top: 20px;">
        <span
          style="margin-right: 6px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"
        ></span>
        <span style="font-weight: 700;">退款信息</span>
      </div>
      <el-table :data="refundList">
         <el-table-column align="center" label="退款id" prop="refundId"></el-table-column>
        <!-- <el-table-column align="center" label="订单号" prop="orderId"> </el-table-column> -->
        <el-table-column align="center" label="退款消息类型">
       <template slot-scope="scope">
        <span style="color:#303133" v-if="scope.row.notifyType=='apply'" >申请中</span>
        <span style="color:#67C23A" v-if="scope.row.notifyType=='agree'">已同意</span>
        <span style="color:#F56C6C" v-if="scope.row.notifyType=='reject'">已拒绝</span>
       </template>
        </el-table-column>
        <el-table-column align="center" label="退款理由" prop="reason"></el-table-column>
        <!-- <el-table-column label="退款创建时间" prop="ctime"></el-table-column> -->
        <!-- <el-table-column label="业务身份" prop="orderTagList"></el-table-column> -->
        <!-- <el-table-column align="center" label="退款进度" >
            <template slot-scope="scope">
                <span v-if="scope.row.isAppeal=='1'"> 申请平台介入为1</span>
                <span v-else>{{scope.row.isAppeal}}</span>
            </template>
        </el-table-column> -->
        <!-- <el-table-column label="售后发起人角色" prop="applyRole"></el-table-column> -->
        <!-- <el-table-column label="商家是否可以申诉1可以" prop="poiCanAppeal"></el-table-column> -->
        <!-- <el-table-column label="用户申请类型" prop="userApplyType"></el-table-column> -->
<el-table-column label="退款图片" align="center" >
    <template slot-scope="scope" v-if="scope.row.pictures!=''">
      <el-image 
      :title="`共${JSON.parse(scope.row.pictures).length} 张`"
    style="width: 100px; height: 100px"
    :src="JSON.parse(scope.row.pictures)[0]" 
    :preview-src-list="JSON.parse(scope.row.pictures)">
  </el-image>
  <span v-if="scope.row.pictures!=''">共{{JSON.parse(scope.row.pictures).length}}张</span>
    </template>

</el-table-column>
<el-table-column label="退款金额" prop="money"></el-table-column>

        <el-table-column align="center" label="处理结果" prop="resType">
            <template slot-scope="scope">
                <span v-if="scope.row.resType==0">未处理</span>
                <span v-if="scope.row.resType==1">商家驳回退款请求</span>
                <span v-if="scope.row.resType==2">商家同意退款</span>
                <span v-if="scope.row.resType==3">客服驳回退款请求</span>
          <span v-if="scope.row.resType==4">客服帮商家同意退款</span>
          <span v-if="scope.row.resType==5">超过3小时自动同意</span>
          <span v-if="scope.row.resType==6">系统自动确认</span>
          <span v-if="scope.row.resType==7">用户取消退款申请</span>
          <span v-if="scope.row.resType==8">用户取消退款申诉</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="退款创建时间" >
            <template slot-scope="scope">
                <span>{{scope.row.refundCreateTime | dataFormat}}</span>
            </template>
        </el-table-column>
      </el-table>


    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id:'',
      couponList: [],
      tableData: [],
      data: {},
      cancelPayData: [],//订单取消信息
      payDatas: [],
      showLastTable: false,
      refundList: []
    };
  },
  methods: {
    getLoadInfo() {
        this.$http.post('/meituanWaimaiOrders/queryOne',{id:this.id}).then(res=>{
            console.log(res)
            this.data=res.data.data.meituanWaimaiOrderActual
            this.data.detail=JSON.parse(this.data.detail)
            this.tableData=this.data.detail //菜品信息
            this.cancelPayData=res.data.data.meituanWaimaiOrderCancelInfoList
            this.refundList=res.data.data.meituanWaimaiOrderRefundInfoList
            console.log(this.data)
        })
    },
    back() {
        this.$router.push('/meituanWaimaiOrder')
    },
    getLoadInfos() {
    }
  },
  created() {
    this.id=this.$route.query.id
    this.getLoadInfo()
  }
};
</script>

<style lang="less" scoped>
.top {
  display: flex;
  justify-content: space-between;
  .left {
    .order-detail {
      color: #333;
      font-weight: 500;
      font-size: 20px;
    }
  }
  .right {
    width: 95px;
  }
}

// 已结账
.yjz {
  padding-left: 8px;
  padding-right: 8px;
  margin-left: 8px;
  color: #fff;
  background-color: #00c8b4;
  font-size: 12px;
  line-height: 24px;
  font-weight: 700;
  border-radius: 2px;
}
.three-card {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  .item {
    width: 27%;
    height: 65px;
    padding: 16px 24px;
    border: 1px solid #e9e9e9;
    .top {
      display: block;
      span {
        font-weight: 700;
      }
    }
    .bottom {
      margin-top: 10px;
      span {
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
}
.three-detail {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  .item {
    border-right: 2px solid transparent;
    width: 27%;
    padding-right: 48px;
    display: flex;
    flex-direction: column;
    span {
      display: inline-block;
      line-height: 22px;
      height: 22px;
      box-sizing: border-box;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 10px;
      span {
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
::-webkit-scrollbar-thumb {
  background: #999;
}
</style>
